// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { FaArrowLeft } from 'react-icons/fa';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const MyServiceProviders = () => {
//   const [providers, setProviders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedProvider, setSelectedProvider] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const navigate = useNavigate();
//   const token = localStorage.getItem('token');

//   useEffect(() => {
//     const fetchProviders = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/my-posts/providers`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setProviders(response.data.providers);
//         console.log(response.data.providers)
//       } catch (error) {
//         toast.error('Error fetching service providers: ' + (error.response?.data.msg || error.message), {
//           position: 'top-right',
//           autoClose: 3000,
//           style: { background: '#F44336', color: 'white' },
//         });
//         navigate('/notifications');
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (!token) {
//       toast.error('Please log in to view service providers', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#F44336', color: 'white' },
//       });
//       navigate('/login');
//       return;
//     }

//     fetchProviders();
//   }, [token, navigate]);

//   const handleViewDetails = (provider) => {
//     setSelectedProvider(provider);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setSelectedProvider(null);
//   };

//   const handleViewService = (serviceId) => {
//     closeModal();
//     navigate(`/service/${serviceId}`);
//   };

//   const handleViewPost = (postId) => {
//     closeModal();
//     navigate(`/post/${postId}`);
//   };

//   if (loading) {
//     return (
//       <div className="h-screen flex items-center justify-center bg-gray-100">
//         <svg
//           className="animate-spin h-8 w-8 text-blue-500"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//         >
//           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//           <path
//             className="opacity-75"
//             fill="currentColor"
//             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//           ></path>
//         </svg>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
//       <div className="flex items-center justify-between mb-6">
//         <div className="flex items-center">
//           <button onClick={() => navigate('/notifications')} className="mr-4 text-blue-500 hover:text-blue-700">
//             <FaArrowLeft size={20} />
//           </button>
//           <h2 className="text-2xl font-bold text-blue-600">Service Providers for Your Posts</h2>
//         </div>
//       </div>
//       {providers.length === 0 ? (
//         <p className="text-gray-500">No service providers have booked your posts yet.</p>
//       ) : (
//         <div className="space-y-4">
//           {providers.map((provider) => (
//             <div
//               key={provider.serviceId}
//               className="p-4 border rounded-lg bg-gray-50"
//             >
//               <div className="flex justify-between items-start">
//                 <div>
//                   <p className="text-gray-800 font-semibold">{provider.providerName}</p>
//                   <p className="text-sm text-gray-500">Email: {provider.providerEmail}</p>
//                   <p className="text-sm text-gray-500">Post: {provider.postTitle}</p>
//                   <p className="text-sm text-gray-500">Role: {provider.roleRequested}</p>
//                   <p className="text-sm text-gray-500">Service: {provider.serviceName}</p>
//                   <p className="text-sm text-gray-500">Status: {provider.status}</p>
//                   <p className="text-xs text-gray-400">
//                     Booked: {new Date(provider.bookedAt).toLocaleString()}
//                   </p>
//                 </div>
//                 <button
//                   onClick={() => handleViewDetails(provider)}
//                   className="ml-4 text-green-500 hover:text-green-700"
//                 >
//                   View Details
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Modal for Provider Details */}
//       {isModalOpen && selectedProvider && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
//             <h3 className="text-xl font-semibold mb-4 text-blue-600">Service Provider Details</h3>
//             <div className="space-y-2">
//               <p className="text-gray-800">
//                 <span className="font-semibold">Name:</span> {selectedProvider.providerName}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Email:</span> {selectedProvider.providerEmail}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Post:</span> {selectedProvider.postTitle}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Role:</span> {selectedProvider.roleRequested}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Service:</span> {selectedProvider.serviceName}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Status:</span> {selectedProvider.status}
//               </p>
//               <p className="text-gray-600">
//                 <span className="font-semibold">Booked:</span> {new Date(selectedProvider.bookedAt).toLocaleString()}
//               </p>
//             </div>
//             <div className="mt-6 flex justify-end space-x-2">
//               <button
//                 onClick={() => handleViewPost(selectedProvider.postId)}
//                 className="py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all"
//               >
//                 View Post
//               </button>
//               <button
//                 onClick={() => handleViewService(selectedProvider.serviceId)}
//                 className="py-2 px-4 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-all"
//               >
//                 View Service
//               </button>
//               <button
//                 onClick={closeModal}
//                 className="py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={3000} />
//     </div>
//   );
// };

// export default MyServiceProviders;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MyServiceProviders = () => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchProviders = async () => {
      if (!token) {
        toast.error('Please log in to view service providers', {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#F44336', color: 'white' },
        });
        navigate('/login');
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}oosh/service/my-posts/providers?_=${Date.now()}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Cache-Control': 'no-cache',
            },
          }
        );
        setProviders(response.data.providers || []);
        console.log('Providers:', response.data.providers);
      } catch (error) {
        console.error('Error fetching providers:', error);
        toast.error(error.response?.data?.msg || 'Error fetching service providers', {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#F44336', color: 'white' },
        });
        navigate('/notifications');
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, [token, navigate]);

  const handleViewDetails = (provider) => {
    setSelectedProvider(provider);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProvider(null);
  };

  const handleViewPost = (postId) => {
    closeModal();
    navigate(`/post/${postId}`);
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-100">
        <svg
          className="animate-spin h-8 w-8 text-blue-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <ToastContainer />
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button onClick={() => navigate('/notifications')} className="mr-4 text-blue-500 hover:text-blue-700">
            <FaArrowLeft size={20} />
          </button>
          <h2 className="text-2xl font-bold text-blue-600">Accepted Service Providers</h2>
        </div>
      </div>
      {providers.length === 0 ? (
        <p className="text-gray-500 text-center">No providers have accepted your posts yet.</p>
      ) : (
        <div className="space-y-4">
          {providers.map((provider) => (
            <div
              key={provider.providerId}
              className="p-4 border rounded-lg bg-gray-50 hover:shadow-md transition"
            >
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-gray-800 font-semibold">{provider.providerName || 'Unknown Provider'}</p>
                  <p className="text-sm text-gray-500">Email: {provider.providerEmail || 'N/A'}</p>
                  <p className="text-sm text-gray-500">Phone Number: {provider.providerPhone || 'N/A'}</p>
                  <p className="text-sm text-gray-500">Post: {provider.postTitle || 'Untitled Post'}</p>
                  <p className="text-sm text-gray-500">Role: {provider.providerModel || 'N/A'}</p>
                  <p className="text-sm text-gray-500"> { 'No reviews yet'}</p>
                  <p className="text-xs text-gray-400">
                    Accepted: {provider.createdAt ? new Date(provider.createdAt).toLocaleString() : 'N/A'}
                  </p>
                </div>
                <button
                  onClick={() => handleViewDetails(provider)}
                  className="ml-4 text-green-500 hover:text-green-700 font-semibold"
                >
                  View Details
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal for Provider Details */}
      {isModalOpen && selectedProvider && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
            <h3 className="text-xl font-semibold mb-4 text-blue-600">Provider Details</h3>
            <div className="space-y-2">
              <p className="text-gray-800">
                <span className="font-semibold">Name:</span> {selectedProvider.providerName || 'Unknown Provider'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Email:</span> {selectedProvider.providerEmail || 'N/A'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Post:</span> {selectedProvider.postTitle || 'Untitled Post'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Role:</span> {selectedProvider.providerModel || 'N/A'}
              </p>
              <p className="text-gray-600">
                <span className="font-semibold">Accepted:</span>{' '}
                {selectedProvider.createdAt ? new Date(selectedProvider.createdAt).toLocaleString() : 'N/A'}
              </p>
            </div>
            <div className="mt-6 flex justify-end space-x-2">
              <button
                onClick={() => handleViewPost(selectedProvider.postId)}
                className="py-2 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all"
              >
                View Post
              </button>
              <button
                onClick={closeModal}
                className="py-2 px-4 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-all"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyServiceProviders;